module.exports = __webpack_public_path__ + "img/timeline-04.2c117177.jpg";